import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@garnish/constants';

import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientListItemTitle = memo((props: PropsWithChildren) => {
  return (
    <BodyText sizeMatch={['22']} style={styles.title}>
      {props.children}
    </BodyText>
  );
});

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    color: theme.colors.KALE,
  },
});
